
export type SendMessageBody = {
  content: string;
  contentType?: string;
  /** @nullable */
  mediaUrl?: string | null;
  /** @nullable */
  replyToMessageId?: string | null;
};
